import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IPowerBIService } from "services/PowerBIService";
import { IntSelectModel } from "services/api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

const initialState = {
  PowerBIReportSelectModels: new Array<IntSelectModel>(),
  Loading: false,
  LastUpdateTime: new Date(),
};

export const PowerBIReportSelectSlice = createSlice({
  name: "PowerBIReports",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPowerBIReportSelectModels.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getPowerBIReportSelectModels.rejected, (state) => {
        state.Loading = false;
        state.PowerBIReportSelectModels = new Array<IntSelectModel>();
        state.LastUpdateTime = new Date();
      })
      .addCase(getPowerBIReportSelectModels.fulfilled, (state, action) => {
        state.PowerBIReportSelectModels = action.payload;
        state.Loading = false;
        state.LastUpdateTime = new Date();
      });
  },
});

export const getPowerBIReportSelectModels = createAsyncThunk("PowerBIReports/GetSelectModels", async () => {
  const powerBIService = container.get<IPowerBIService>(SERVICE_TYPES.PowerBIService);
  return await powerBIService.getReportSelectModels();
});

export const selectReportSelectModels = (state: RootState) => state.powerBIReportsSelect.PowerBIReportSelectModels;
export const selectLoadingReports = (state: RootState) => state.powerBIReportsSelect.Loading;
export const selectLastUpdateTime = (state: RootState) => state.powerBIReportsSelect.LastUpdateTime;

export default PowerBIReportSelectSlice.reducer;
